import React from "react";

function getBadgeStyle(status) {
  if (status === "acabou") return "bg-red-50 text-red-700 border-red-200";
  if (status === "acabando") return "bg-amber-50 text-amber-700 border-amber-200";
  if (status === "disponivel") return "bg-emerald-50 text-emerald-700 border-emerald-200";
  return "bg-gray-50 text-gray-600 border-gray-200";
}

function getStatusLabel(status) {
  if (status === "acabou") return "Sem estoque";
  if (status === "acabando") return "Atenção";
  if (status === "disponivel") return "Disponível";
  return "Inativo";
}

function getEmphasisColor(status) {
  if (status === "acabou") return "#DC2626";
  if (status === "acabando") return "#D97706";
  if (status === "disponivel") return "#059669";
  return "#6B7280";
}

function getTypeLabel(type) {
  if (type === "INJETAVEL") return "Injetável";
  if (type === "COMPRIMIDO") return "Comprimido";
  if (type === "CAPSULA") return "Cápsula";
  if (type === "LIQUIDO") return "Líquido";
  if (type === "PO") return "Suplemento em Pó";
  return "Medicação";
}

function getMedicationIcon(type) {
  if (type === "INJETAVEL") return "💉";
  if (type === "CAPSULA") return "💊";
  if (type === "LIQUIDO") return "🧴";
  if (type === "PO") return "🥤";
  if (type === "COMPRIMIDO") return "💊";
  return "💊";
}

export default function MedicationCard({
  name,
  status,
  medicationType,
  availableTotalLabel,
  onViewDetail,
}) {
  const badgeStyle = getBadgeStyle(status);
  const statusLabel = getStatusLabel(status);
  const emphasisColor = getEmphasisColor(status);
  const typeLabel = getTypeLabel(medicationType);
  const medicationIcon = getMedicationIcon(medicationType);

  const isCritical = status === "acabou" || status === "acabando";

  return (
    <div className={`glass-card glass-card-hover rounded-3xl p-4 sm:p-5 transition-all duration-300 ${isCritical ? "border-l-4 border-l-amber-500" : ""}`}>
      {/* HEADER */}
      <div className="flex items-start justify-between gap-3">
        <div className="flex items-center gap-3.5 min-w-0">
          <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-purple-100/80 text-xl shadow-sm border border-purple-200/50">
            {medicationIcon}
          </div>

          <div className="min-w-0">
            <h3 className="text-sm font-extrabold text-[#2A1F45] truncate">
              {name || "Medicação sem nome"}
            </h3>
            <p className="text-xs font-semibold text-purple-700">
              {typeLabel}
            </p>
          </div>
        </div>

        <span className={`inline-flex items-center rounded-full px-2.5 py-1 text-[10px] font-extrabold border ${badgeStyle}`}>
          {statusLabel}
        </span>
      </div>

      {/* ESTOQUE */}
      <div className="mt-4 space-y-2">
        <div className="flex items-center justify-between text-xs">
          <span className="font-semibold text-gray-500">Disponível em Estoque</span>
          <span className="font-extrabold" style={{ color: emphasisColor }}>
            {availableTotalLabel || "—"}
          </span>
        </div>

        {/* BARRA VISUAL */}
        <div className="w-full h-2 rounded-full bg-purple-100/60 overflow-hidden">
          <div
            className="h-full rounded-full transition-all duration-500"
            style={{
              width:
                status === "acabou"
                  ? "8%"
                  : status === "acabando"
                  ? "38%"
                  : "82%",
              backgroundColor: emphasisColor,
            }}
          />
        </div>
      </div>

      {/* BOTÃO */}
      <button
        type="button"
        onClick={onViewDetail}
        className="mt-4 w-full rounded-2xl border border-purple-200/80 bg-white hover:bg-purple-50 active:scale-95 text-purple-800 py-2.5 text-xs font-bold shadow-sm transition-all duration-200"
      >
        Ver detalhes
      </button>
    </div>
  );
}